/**
 * Utility function to validate URLs from editorial content
 * Can be used for both rich text links and direct URL fields
 */

/**
 * Validates a URL string for common malformed patterns
 * @param {string} url - The URL to validate
 * @returns {object} - { valid: boolean, errors: string[], warnings: string[] }
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export function validateUrl(url) {
  const errors = []
  const warnings = []

  if (!url || typeof url !== "string") {
    return { valid: true, errors, warnings }
  }

  // Check for obviously malformed patterns
  const malformedPatterns = [
    {
      pattern: /\/blog\/getzestlife\.com/,
      message: "Domain used as blog UID",
      severity: "error",
    },
    {
      pattern: /\/blog\/www\.getzestlife\.com/,
      message: "www domain used as blog UID",
      severity: "error",
    },
    {
      pattern: /\/blog\/http/,
      message: "HTTP protocol in blog UID",
      severity: "error",
    },
    {
      pattern: /\/blog\/https/,
      message: "HTTPS protocol in blog UID",
      severity: "error",
    },
  ]

  for (const { pattern, message, severity } of malformedPatterns) {
    if (pattern.test(url)) {
      if (severity === "error") {
        errors.push(`Malformed URL: ${message}`)
      } else {
        warnings.push(`Malformed URL: ${message}`)
      }
    }
  }

  // Check internal blog links
  if (url.startsWith("/blog/")) {
    const uid = url.replace("/blog/", "")
    if (uid.includes(".") && !uid.endsWith(".pdf")) {
      warnings.push(`Blog UID contains dot: "${uid}" - might be a domain`)
    }
    if (uid.includes("http")) {
      errors.push(`Blog UID contains "http": "${uid}"`)
    }
    if (uid.includes("www")) {
      warnings.push(`Blog UID contains "www": "${uid}"`)
    }
    if (uid.length === 0) {
      errors.push("Empty blog UID")
    }
    if (uid.length > 100) {
      warnings.push(`Blog UID is very long (${uid.length} chars)`)
    }
  }

  // Check for external URLs missing a protocol
  if (
    !url.startsWith("http://") &&
    !url.startsWith("https://") &&
    !url.startsWith("/") &&
    !url.startsWith("#") &&
    !url.startsWith("mailto:") &&
    url.includes(".")
  ) {
    errors.push(
      `URL appears to be an external link but is missing a protocol (http:// or https://): "${url}"`,
    )
  }

  // Validate absolute URLs
  if (url.startsWith("http://") || url.startsWith("https://")) {
    try {
      new URL(url)
    } catch (e) {
      errors.push(`Invalid absolute URL: ${e.message}`)
    }
  }

  return {
    valid: errors.length === 0,
    errors,
    warnings,
  }
}

/**
 * Checks if a URL is safe to use
 * @param {string} url - The URL to check
 * @returns {boolean} - true if URL is safe, false if malformed
 */
export function isUrlSafe(url) {
  const { valid } = validateUrl(url)
  return valid
}
